var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.list && _vm.list.length > 0
    ? _c("section", { staticClass: "video-model" }, [
        _c("h3", [_vm._v("热点视频")]),
        _vm._v(" "),
        _c(
          "ul",
          { staticClass: "video-model-list" },
          _vm._l(_vm.list, function (item, index) {
            return _c(
              "li",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.show(index),
                    expression: "show(index)",
                  },
                ],
                key: index,
                attrs: {
                  "data-exposed": "false",
                  "data-report": JSON.stringify({ hot_video: item.name }),
                },
              },
              [
                _c(
                  "a",
                  {
                    attrs: {
                      href: item.link,
                      uigs: "out_home_hot_" + index,
                      "data-report": JSON.stringify({
                        hot_video_click: item.name,
                      }),
                    },
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "video-model-img-h" },
                      [_c("img-item", { attrs: { src: item.img_url } })],
                      1
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "video-model-info" }, [
                      _c("p", [_vm._v(_vm._s(item.name))]),
                    ]),
                  ]
                ),
              ]
            )
          }),
          0
        ),
        _vm._v(" "),
        _c("div", { staticClass: "video-model-btn" }, [
          _c(
            "a",
            {
              attrs: { uigs: "home_hot_video_change" },
              on: { click: _vm.change },
            },
            [_c("span", { staticClass: "change" }, [_vm._v("换一换")])]
          ),
        ]),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }